import { FeaturedJob } from 'rwl-shared/dist/models';
import {
    isCustomerTypeLabel,
    isCustomLabel,
    isJobTypeLabel,
    isServiceTypeLabel,
} from 'rwl-shared/dist/utils/label';

export const getJobDescription = (job: FeaturedJob): string | undefined => {
    let description: string | undefined = undefined;
    if (job.description && job.description.length > 0) {
        description = job.description;
    } else if (job.labels && job.labels.length > 0) {
        description = job.labels
            .filter(
                (label) =>
                    isServiceTypeLabel(label) ||
                    isJobTypeLabel(label) ||
                    isCustomerTypeLabel(label) ||
                    isCustomLabel(label)
            )
            .map((label) => label.name)
            .join(' - ');
    } else if (job.reviewMessages && job.reviewMessages.length > 0) {
        description = `"${job.reviewMessages[0]}"`;
    }
    return description;
};
